import type { SITE_WORKING_CONDITION_ACQUISITION_PILOTS_TABLE_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-working-condition-acquisition-pilots-table/site-working-condition-acquisition-pilots-table.fr.ts";

export const SITE_WORKING_CONDITION_ACQUISITION_PILOTS_TABLE_ENGLISH_LOCALE = {
  headers: {
    csId: "Pilot Cs Id",
    hwId: "Pilot Hw Id",
    name: "Name",
    lastSyncDate: "Last sync. date",
    serialNumber: "Serial number",
    softwareVersion: "Software version",
  },
  empty: "No pilot",
} satisfies typeof SITE_WORKING_CONDITION_ACQUISITION_PILOTS_TABLE_FRENCH_LOCALE;
